export default {
    toggleLoading ({ commit }, value) {
        commit('toggleLoading', value)
    },
    errorModal ({commit}, value){
        commit('errorModal', value)
    },
    consentModal ({commit}, value){
        commit('consentModal', value);
    },
    clarifyModal ({commit}, value){
        commit('clarifyModal', value);
    },
    kvkkModal ({commit}, value){
        commit('kvkkModal', value);
    }
}